import { render, staticRenderFns } from "./VideoSlideCard.vue?vue&type=template&id=5ac42fe7&scoped=true&"
import script from "./VideoSlideCard.vue?vue&type=script&lang=js&"
export * from "./VideoSlideCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoSlideCard.vue?vue&type=style&index=0&id=5ac42fe7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac42fe7",
  null
  
)

export default component.exports